import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { leadsDropdownRequest } from "../../containers/myactivity/actions";
import { dispatchSnackbarError, dispatchSnackbarSuccess } from "../../utils/toaster";
import SearchSelect from "./searchSelect";
import { useDispatch } from "react-redux";
import { InputLimit } from "../../constants";
import { Dropdown, Spinner, Form } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function LeadSelect({ field, value, setValue }) {
  const dispatch = useDispatch();
  const [newPeopleName, setNewPeopleName] = useState("");
  const Store = useSelector((state) => state.Myactivity.leadDropdownList);
  const newStore = useSelector((state) => state.Myactivity.newLead);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (!newStore) {
      setSelected({
        label: Store.list.find((company) => company["_id"] === value) ? Store.list.find((company) => company["_id"] === value).name : null,
        value: value,
      });
    }
  }, [Store, value, newStore]);

  useEffect(() => {
    if (value) {
      setSelected({
        label: Store.list.find((company) => company["_id"] === value) ? Store.list.find((company) => company["_id"] === value).name : null,
        value: value,
      });
    }
  }, [Store, value]);

  useEffect(() => {
    if (newStore) {
      setValue(newStore.id, field.apiKeyName);
      dispatchSnackbarSuccess("Company Added Successfuly");
      setSelected({
        label: newStore.name,
        value: newStore.id,
      });
      //   dispatch(leadsDropdownAddClear())
    }
  }, [newStore, dispatch, field, setValue]);

  useEffect(() => {
    var temp = [];
    for (var i = 0; i < Store.list.length; i++) temp.push({ value: Store.list[i]["_id"], label: Store.list[i]["name"] });
    // temp.push({value:"new",label:"+ Add "+newPeopleName})
    setOptions(temp);
  }, [Store, newPeopleName]);

  const handleSave = () => {
    if (newPeopleName.trim() === "") {
      dispatchSnackbarError("Name can not be blank!");
      return;
    }
    // dispatch(leadsDropdownAddRequest({name:newPeopleName}))
  };

  return <SearchSelect options={options} selected={selected} setValue={setValue} handleSave={handleSave} setSearch={setNewPeopleName} field={field} loading={Store.loading} request={leadsDropdownRequest} />;
}

export function LeadSelectDropdown({ field, setValue, value }) {
  const Store = useSelector((state) => state.Myactivity.leadDropdownList);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    var temp = [];
    for (var i = 0; i < Store.list.length; i++) temp.push({ _id: Store.list[i]["_id"], name: Store.list[i]["name"] });
    setOptions(temp);
  }, [Store]);

  const onSearch = (value) => {
    dispatch(leadsDropdownRequest(value));
    setSearch(value);
  };

  const [selected, setSelected] = useState(value);
  return (
    <Dropdown className="dropdown-inline mt-1 w-100">
      <Dropdown.Toggle className="w-100 text-left py-0-point-65rem px-1-point-1rem border-width-1px border-style-solid border-color-e4e6ef" variant="transparent">
        {!value || !selected || value === "" ? "Select " + field.fieldName : selected.name}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu w-100-mn">
        {false ? (
          <div className="w-100 d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="navi navi-hover">
            {
              <li className="navi-item py-20px px-24px">
                <Form.Control maxLength={InputLimit.TEXT} type="text" placeholder="Search Lead" value={search} onChange={(e) => onSearch(e.target.value)} />
              </li>
            }
            <Dropdown.Divider className="m-0" />
            <PerfectScrollbar className="scroll navi navi-hover h-25vh-mx position-relative" options={{ wheelSpeed: 0.4, wheelPropagation: false }}>
              {options && options.length === 0 ? (
                <div className="w-100 d-flex flex-center h-50px-mn">
                  <span>No Leads</span>
                </div>
              ) : (
                options.map((each, index) => {
                  return (
                    <Dropdown.Item
                      className="dropdown-hover"
                      key={index}
                      onSelect={() => {
                        setSelected(each);
                        setValue(each, field.apiKeyName);
                      }}
                    >
                      {each.name}
                    </Dropdown.Item>
                  );
                })
              )}
            </PerfectScrollbar>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
